import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    wrapper: {
        position: 'relative'
    },
    menu: {
        position: 'absolute',
        zIndex: 9,
        background: 'white',
        right: 0,
        minWidth: '124px',
        maxWidth: '100%',
        top: 'calc(100% + 3px)'
    },
}))

export default useStyles;
